import { makeHttpRequest } from "@/shared";

import { mapDirectorFromServer } from "./mappers/mapDirectorFromServer";

export const getDirector = async (id) => {
    const response = (
        await makeHttpRequest({
            url: `/director/${id}`,
            method: "GET",
        })
    ).data;

    return { director: mapDirectorFromServer(response.data) };
};
